import { BLOCK_REGISTRY } from "../blockRegistry";

const NAVBAR_DEFAULT_BLOCKS = [
  { id: "default-navbar-content", type: "navbar-content" },
].map((block) => ({
  ...block,
  fields: BLOCK_REGISTRY[block.type].defaultFields,
}));

export default NAVBAR_DEFAULT_BLOCKS;
